module.exports = __webpack_public_path__ + "img/down-gz3.507fa454.jpg";